import React, {Component} from 'react';

class SectionSideController extends Component{
  constructor(props){
    super(props);
  }
  render(){
    return(
      <div dangerouslySetInnerHTML={{__html: this.props.content}} />
    )
  }
}

export default SectionSideController;



// WEBPACK FOOTER //
// ./src/components/homepage/views/sectionSide.js